import { adapter, Service } from 'components/system';
import { CustomerActiveDataProvider } from 'common/customers/services/customerActiveDataProvider';

const service = class extends Service {
    private _$http: any;
    private customerActiveDataProvider: CustomerActiveDataProvider;
    private statusDisabled: any;
    /**
     * @return {string}
     */
    static get $name() {
        return 'customerCompanyArchivedService';
    }

    /**
     * @return {string[]}
     */
    static get $inject() {
        return ['$http'];
    }

    /**
     * @param $http
     */
    constructor($http: angular.IHttpService) {
        super();
        this._$http = $http;
        this.customerActiveDataProvider = CustomerActiveDataProvider.getInstance();

        this.setDisabledAll();
    }

    /**
     * @param {string} mode 'archive/unarchive'
     * @returns {boolean}
     */
    getStatusDisabled(mode) {
        return this.statusDisabled[mode];
    }

    setDisabledAll() {
        this.statusDisabled = {
            archive: true,
            unarchive: true
        };
    }

    /**
     * @param {number} selectionId
     */
    checkStatusDisabled(selectionId) {
        this._$http.get(`middle://rs/selection/customers/${selectionId}/activeness`, {}).then(response => {
            let archiveStatus = true,
                unarchiveStatus = true;

            if (response && response.data) {
                response = response.data;

                if (response.active > 0 && response.inactive === 0) {
                    archiveStatus = false;
                } else if (response.active === 0 && response.inactive > 0) {
                    unarchiveStatus = false;
                }
            }

            this.statusDisabled = {
                archive: archiveStatus,
                unarchive: unarchiveStatus
            };
        });
    }

    /**
     * @param {number} selectionId
     * @param {string} type 'customer/company'
     * @param {string} mode 'archive/unarchive'
     */
    action(selectionId, type, mode) {
        if (type === 'customer') {
            return this.customerActiveDataProvider
                .update(
                    {
                        active: !(mode === 'archive'),
                        selectionId: selectionId
                    },
                    {}
                )
                .then(() => {
                    this.setDisabledAll();
                });
        }
    }
};

adapter.linkService(service);
